import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import SortableTableHeader from '../../../../common/SortableTableHeader/SortableTableHeader';
import { selectQuietTimes } from '../../../../../redux/slices/quietTimesSlice/quietTimesSlice';
import QuietTimeListTableRow from './QuietTimeListTableRow/QuietTimeListTableRow';

const columnHeaders = [
  { label: 'Name', sortType: 'name' },
  { label: 'Includes...', sortType: 'timeString' },
  { label: 'Used In...', sortType: 'uniqueAlertCount' },
];

function QuietTimeListTable() {
  const quietTimeList = useSelector(selectQuietTimes);
  const [sortCol, setSortCol] = useState('');
  const [sortOrder, setSortOrder] = useState('ASC');
  const [sortedList, setSortedList] = useState([]);

  const handleSetSortingOrder = (colName, order) => {
    setSortCol(colName);
    setSortOrder(order);
  };

  useEffect(() => {
    const sorted = [...quietTimeList].sort((a, b) => {
      const itemA = a[sortCol];
      const itemB = b[sortCol];
      if (sortOrder === 'ASC') {
        if (itemA < itemB) {
          return -1;
        }
        if (itemA > itemB) {
          return 1;
        }
      } else {
        if (itemA > itemB) {
          return -1;
        }
        if (itemA < itemB) {
          return 1;
        }
      }
      return 0;
    });
    setSortedList(sorted);
  }, [sortCol, sortOrder, quietTimeList]);

  return (

    <table
      className="table table-hover table-sm table-condensed table-striped my-1"
    >
      <thead className="thead-light">
        <tr>
          {columnHeaders.map((col) => (
            <React.Fragment key={col.label}>
              <SortableTableHeader
                onAscClick={
                      () => handleSetSortingOrder(col.sortType, 'ASC')
                    }
                onDescClick={() => handleSetSortingOrder(col.sortType, 'DES')}
                label={col.label}
                isSelected={col.sortType === sortCol}
              />
            </React.Fragment>
          ))}

          <th className="thead-light">
            {' '}
          </th>
        </tr>
      </thead>
      <tbody>
        {sortedList.length > 0 && sortedList.map((quietTime) => (
          <React.Fragment key={quietTime.id}>
            <QuietTimeListTableRow quietTime={quietTime} />
          </React.Fragment>
        ))}
      </tbody>
    </table>
  );
}

export default QuietTimeListTable;
